import { useContext } from 'react';
import { TelegramContext } from '../contexts/TelegramContext';

export default function useTelegram() {
  return useContext(TelegramContext);
}
